import { environment } from "../../environments/environment";

export class BackendConstants {
    static BACKEND_URL = environment.apiUrl
}